export const primaryTargetCountryOption = [
  { label: "United States", value: "US" },
  { label: "United Kingdom", value: "GB" },
  { label: "Canada", value: "CA" },
  { label: "Australia", value: "AU" },
  { label: "Netherlands", value: "NL" },
  { label: "Germany", value: "DE" },
  { label: "France", value: "FR" },
  { label: "Belgium", value: "BE" },
  { label: "Italy", value: "IT" },
  { label: "Spain", value: "ES" },
  { label: "Portugal", value: "PT" },
  { label: "Sweden", value: "SE" },
  { label: "Denmark", value: "DK" },
  { label: "Norway", value: "NO" },
  { label: "Finland", value: "FI" },
  { label: "Ireland", value: "IE" },
  { label: "Austria", value: "AT" },
  { label: "Switzerland", value: "CH" },
  { label: "Poland", value: "PL" },
  { label: "Czechia", value: "CZ" },
  { label: "Japan", value: "JP" },
  { label: "India", value: "IN" },
  { label: "Pakistan", value: "PK" },
  { label: "United Arab Emirates", value: "AE" },
  { label: "Saudi Arabia", value: "SA" },
  { label: "Brazil", value: "BR" },
  { label: "Mexico", value: "MX" },
  { label: "New Zealand", value: "NZ" },
  { label: "Singapore", value: "SG" },
];
export const contentLanguageOptions = [
  { label: "English", value: "en" },
  { label: "French", value: "fr" },
  { label: "Spanish", value: "es" },
  { label: "German", value: "de" },
  { label: "Italian", value: "it" },
  { label: "Portuguese", value: "pt" },
  { label: "Dutch", value: "nl" },
  { label: "Russian", value: "ru" },
  { label: "Chinese (Simplified)", value: "zh" },
  { label: "Japanese", value: "ja" },
  { label: "Korean", value: "ko" },
  { label: "Arabic", value: "ar" },
  { label: "Hindi", value: "hi" },
  { label: "Bengali", value: "bn" },
  { label: "Turkish", value: "tr" },
  { label: "Vietnamese", value: "vi" },
  { label: "Polish", value: "pl" },
  { label: "Swedish", value: "sv" },
  { label: "Czech", value: "cs" },
  { label: "Greek", value: "el" },
  { label: "Thai", value: "th" },
  { label: "Hebrew", value: "he" },
  { label: "Romanian", value: "ro" },
  { label: "Hungarian", value: "hu" },
  { label: "Finnish", value: "fi" },
  { label: "Danish", value: "da" },
  { label: "Norwegian", value: "no" },
  { label: "Ukrainian", value: "uk" },
  { label: "Malay", value: "ms" },
  { label: "Indonesian", value: "id" },
  { label: "Filipino", value: "fil" },
  { label: "Slovak", value: "sk" },
  { label: "Bulgarian", value: "bg" },
  { label: "Croatian", value: "hr" },
  { label: "Serbian", value: "sr" },
  { label: "Slovenian", value: "sl" },
  { label: "Estonian", value: "et" },
  { label: "Latvian", value: "lv" },
  { label: "Lithuanian", value: "lt" },
  { label: "Catalan", value: "ca" },
  { label: "Basque", value: "eu" },
  { label: "Galician", value: "gl" },
  { label: "Icelandic", value: "is" },
  { label: "Irish", value: "ga" },
  { label: "Maltese", value: "mt" },
  { label: "Albanian", value: "sq" },
  { label: "Macedonian", value: "mk" },
  { label: "Swahili", value: "sw" },
  { label: "Afrikaans", value: "af" },
];

export const conditionOptions = [
  { label: "New", value: "new" },
  { label: "Used", value: "used" },
  { label: "Refurbished", value: "refurbished" },
];

export const productCategoryOptions = [];
export const genderOptions = [
  { label: "Male", value: "male" },
  { label: "Female", value: "female" },
  { label: "Unisex", value: "unisex" },
];

export const ageOptions = [
  { label: "Adult", value: "adult" },
  { label: "Infant", value: "infant" },
  { label: "Kids", value: "kids" },
  { label: "Newborn", value: "newborn" },
  { label: "Toddler", value: "toddler" },
];

export const sizeSystemOptions = [
  { label: "AU", value: "au" },
  { label: "BR", value: "br" },
  { label: "CN", value: "cn" },
  { label: "DE", value: "de" },
  { label: "EU", value: "eu" },
  { label: "FR", value: "fr" },
  { label: "IT", value: "it" },
  { label: "JP", value: "jp" },
  { label: "MEX", value: "mex" },
  { label: "UK", value: "uk" },
  { label: "US", value: "us" },
];

export const sizeTypeOptions = [
  { label: "Regular", value: "regular" },
  { label: "Petite", value: "petite" },
  { label: "Maternity", value: "maternity" },
  { label: "Oversize (Plus)", value: "oversize" },
  { label: "Tall", value: "tall" },
  { label: "Big", value: "big" },
];

export const unitOptions = [
  { label: "unit", value: "unit" },
  { label: "oz", value: "oz" },
  { label: "lb", value: "lb" },
  { label: "mg", value: "mg" },
  { label: "g", value: "g" },
  { label: "kg", value: "kg" },
  { label: "floz", value: "floz" },
  { label: "pt", value: "pt" },
  { label: "qt", value: "qt" },
  { label: "gal", value: "gal" },
  { label: "ml", value: "ml" },
  { label: "cl", value: "cl" },
  { label: "l", value: "l" },
  { label: "cbm", value: "cbm" },
  { label: "in", value: "in" },
  { label: "ft", value: "ft" },
  { label: "yd", value: "yd" },
  { label: "cm", value: "cm" },
  { label: "m", value: "m" },
  { label: "sqft", value: "sqft" },
  { label: "sqm", value: "sqm" },
  { label: "ct", value: "ct" },
];
